import { useFeatureLoyaltyHowItWorksQuery } from 'generated/sanity-graphql';

export const useLoyaltyHowItWorks = (featureLoyaltyHowItWorksId: string) => {
  const { data, loading, error } = useFeatureLoyaltyHowItWorksQuery({
    variables: {
      featureLoyaltyHowItWorksId,
    },
    skip: !featureLoyaltyHowItWorksId,
  });

  const howItWorksContent = data?.FeatureLoyaltyHowItWorks;

  return {
    loading,
    error,
    pageTitle: howItWorksContent?.pageTitle?.locale,
    callToActionText: howItWorksContent?.callToAction?.locale,
    steps: howItWorksContent?.howItWorksSteps || [],
  };
};
